export default __webpack_public_path__ + "static/media/200.db2d23de.gif";